const parseEmails = (string) => ((string && string.split(', ')) || ['']);

export { parseEmails };
